(function(){
'use strict';
var q=document.querySelector('.mr-q');
if(!q)return;
/* Edit this list to change the examples. Each line is one placeholder. */
var L=[
 'Search e.g. knee pain, stiff joints, arthritis',
 'Search e.g. night cramps, restless legs, sore muscles',
 'Search e.g. hip pain, tight shoulders, stiff hands',
 'Search e.g. sore after a run, sleeping through the night',
 'Search e.g. wrinkles, fine lines, dry or itchy skin',
 'Search e.g. rosacea, redness, flushing, acne',
 'Search e.g. make-up, cleanser, delivery, service'
];
q.placeholder=L[0];
if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var i=0;
setInterval(function(){
 if(document.hidden||document.activeElement===q||q.value)return;
 q.classList.add('ph-out');
 setTimeout(function(){i=(i+1)%L.length;q.placeholder=L[i];q.classList.remove('ph-out')},300)
},3000);
})();
